module.exports = __webpack_public_path__ + "static/media/about.3298aa97.jpg";